var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('st-page',{attrs:{"title":this.$t('PERMISSIONS.HEADER')},scopedSlots:_vm._u([{key:"toolbar",fn:function(){return [_c('permissions-list-toolbar')]},proxy:true}])},[_c('permissions-list-filter',[_c('permissions-list-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }